import React, { useState, useEffect, ReactNode } from 'react';
import { ButtonLink } from './Styles.jsx';

interface ContainerProps {
  open: Function;
  theme: any;
  text: ReactNode;
  classx: any;
  id: any;
}

const ModalButton: React.FC<ContainerProps> = ({ open, theme, text, classx, id }) => {
  const [largeFont, setLargeFont] = useState(false);

  useEffect(() => {
    const triggerElement = document.querySelector('#dealer-locator-react-pdp');
    if (triggerElement?.getAttribute('data-large-text') === 'true') {
      setLargeFont(true);
    }
  }, []);

  const baseClass = theme?.toLowerCase?.() === 'jackson' ? 'jackson-dealer-locator-button' : 'dealer-locator-button';
  const combinedClassName = `${baseClass} ${classx || ''}`.trim();

  return (
    <ButtonLink
      id={id}
      className={combinedClassName}
      theme={theme}
      onClick={() => open()}
    >
      <span style={{ fontSize: largeFont ? '1.5rem' : 'initial' }}>{text}</span>
    </ButtonLink>
  );
};

export default ModalButton;
